import axios from 'axios'
import { setCookie, getCookie } from '../cookies'
import { ID_DATA } from '~/js/constants/data-element-ids'

const date = new Date()
const dateString = `${date.getFullYear()}-${(date.getMonth() + 1)
  .toString()
  .padStart(2, '0')}-${date.getDate()}`

const isPointIssued = ({ customerCode }) => {
  const loginCookie = getCookie(`login_${customerCode}`)
  if (!loginCookie) return false
  return loginCookie === dateString
}

const issueLoginPoint = async ({ customerCode, baseUrl }) => {
  if (!customerCode) return
  if (isPointIssued({ customerCode })) return

  try {
    const { data } = await axios.post(`${baseUrl}/login_point/issue`, {
      customerCode,
    })
    setCookie(`login_${customerCode}`, data.loginDate, 1)
  } catch (error) {
    console.error(error)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const { baseUrlFrontNamed, customerCode } =
    document.getElementById(ID_DATA).dataset
  issueLoginPoint({ customerCode, baseUrl: baseUrlFrontNamed })
})
